import Aegis from 'aegis-web-sdk'
import { getConfig } from '../config'

const reportAegis = (config) => {
  if (window.aegis) {
    return window.aegis
  }
  const opt = Object.assign(
    {
      id: config.id, // 项目key  --控制台
      // uin: 'xxx', // UIN (optional)
      reportApiSpeed: true, // 接口测速
      reportAssetSpeed: true, // 静态资源测速
      spa: true, // spa 页面需要开启，页面切换的时候上报pv
      hostUrl: config.hostUrl,
      onError: true, // 错误日志
      performanceUrl: config.performanceUrl // 页面性能日志上报
    },
    config
  )
  window.aegis = new Aegis(opt)
}
export const initAegis = () => {
  const config = getConfig()
  console.log('config-env:', config.env)
  if (config.env === 'production' && config.aegisConfig.enable) {
    reportAegis(getConfig().aegisConfig)
  }
}



// WEBPACK FOOTER //
// ./src/utils/aegis.js